import React from "react";
import { Box, Button, Typography } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import { COLORS, FONT } from "../../constants";
import useSystemHook from "../../hooks/SystemHook";

const ReadyToTrade = ({ onNewTrade, onExistingTrade }) => {
  const { isMobile } = useSystemHook();

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: COLORS.themeYellow,
        py: isMobile ? 8 : 10,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* Abstract automotive background art */}
      <SettingsOutlinedIcon
        sx={{
          position: "absolute",
          top: -60,
          left: -60,
          fontSize: 280,
          color: COLORS.themeBlack,
          opacity: 0.06,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <SettingsOutlinedIcon
        sx={{
          position: "absolute",
          bottom: -70,
          right: -50,
          fontSize: 240,
          color: COLORS.themeBlack,
          opacity: 0.06,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <BuildOutlinedIcon
        sx={{
          position: "absolute",
          top: "20%",
          right: "12%",
          fontSize: 120,
          color: COLORS.themeBlack,
          opacity: 0.04,
          transform: "rotate(-25deg)",
          pointerEvents: "none",
          userSelect: "none",
        }}
      />

      <Typography
        variant="h3"
        sx={{
          position: "relative",
          fontWeight: 600,
          color: COLORS.themeBlack,
          fontSize: isMobile ? FONT.size.lg : FONT.size.h3,
          letterSpacing: 1,
          textTransform: "uppercase",
          mb: 5,
          zIndex: 1,
        }}
      >
        Are You Ready To Trade?
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          alignItems: "center",
          zIndex: 1,
        }}
      >
        <Button
          variant="contained"
          onClick={onNewTrade}
          sx={{
            backgroundColor: COLORS.themeBlack,
            color: COLORS.white,
            fontWeight: 500,
            px: 5,
            py: 1.75,
            borderRadius: "2px",
            textTransform: "none",
            fontSize: isMobile ? FONT.size.sm : FONT.size.md,
            boxShadow: "none",
            width: isMobile ? "100%" : "auto",
            "&:hover": { backgroundColor: COLORS.themeBlack, boxShadow: "none" },
          }}
        >
          New Trade Account
        </Button>
        <Button
          variant="outlined"
          onClick={onExistingTrade}
          sx={{
            borderColor: COLORS.themeBlack,
            borderWidth: 2,
            color: COLORS.themeBlack,
            fontWeight: 500,
            px: 5,
            py: 1.75,
            borderRadius: "2px",
            textTransform: "none",
            fontSize: isMobile ? FONT.size.sm : FONT.size.md,
            width: isMobile ? "100%" : "auto",
            "&:hover": {
              borderColor: COLORS.themeBlack,
              borderWidth: 2,
              backgroundColor: "rgba(0,0,0,0.06)",
            },
          }}
        >
          Existing Trade Account
        </Button>
      </Box>
    </Box>
  );
};

export default ReadyToTrade;
